import classnames from 'classnames';
import { useContext } from 'react';
import type { Color } from 'palette/Colors';
import { ConfigContext } from 'palette/Config';
import { LogoName } from 'palette/Logo';
import { Svg } from 'palette/Svg';
import { IconName, Size, StrokeWidth } from './constants';
import './Icon.scss';

export interface IconProps {
    ariaHidden?: boolean;
    size?: Size;
    name: IconName | LogoName;
    className?: string;
    color?: Color;
    fill?: Color;
    svgUrl?: string;
    stroke?: Color;
    strokeWidth?: StrokeWidth;
    modifier?: 'pr12' | 'pl12';
}

function Icon({
    ariaHidden = false,
    size = 'medium',
    name,
    className,
    color,
    fill,
    svgUrl,
    stroke,
    strokeWidth = 'regular',
    modifier,
}: IconProps) {
    const { svgPath } = useContext(ConfigContext);
    const rootClasses = classnames(
        'icon',
        { [`icon--color-${color}`]: color },
        `icon--size-${size}`,
        {
            [`icon--fill-${fill}`]: fill,
            [`icon--stroke-${stroke}`]: stroke,
            [`icon--stroke-width-${strokeWidth}`]: strokeWidth,
            [`icon--modifier-${modifier}`]: modifier,
        },
        className,
    );

    return (
        <div
            aria-hidden={ariaHidden}
            className={rootClasses}
        >
            <Svg
                ariaHidden
                name={name}
                svgUrl={svgUrl ?? svgPath ?? ''}
            />
        </div>
    );
}

export default Icon;
